import React, { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Input, NumberInput } from "../../../../../../common/Input";

const LeaveCreditsTabAddEditModal = ({ isOpen, onClose, selectedItem, onSave }) => {
  const [form, setForm] = useState({
    totalLeaveCredit: "",
    remainingLeaveCredit: "",
  });

  useEffect(() => {
    if (isOpen) {
      if (selectedItem) {
        setForm({
          ...selectedItem,
          // INITIAL PHASE: Convert database 0 to empty string "" 
          // so that the NumberInput displays the placeholder on load.
          totalLeaveCredit: selectedItem.totalLeaveCredit === 0 ? "" : selectedItem.totalLeaveCredit,
          remainingLeaveCredit: selectedItem.remainingLeaveCredit === 0 ? "" : selectedItem.remainingLeaveCredit,
        });
      } else {
        setForm({
          totalLeaveCredit: "",
          remainingLeaveCredit: "",
        });
      }
    }
  }, [selectedItem, isOpen]);

  const handleInputChange = (field, value, isDecimal = false) => {
    // If the user clears the input completely
    if (value === "") {
      setForm((prev) => ({ ...prev, [field]: "" }));
      return;
    }

    // Convert string input to number
    const numValue = isDecimal ? parseFloat(value) : parseInt(value, 10);

    // If the conversion is valid (including 0), update state.
    // This allows the user to specifically type "0" and see it on screen.
    setForm((prev) => ({
      ...prev,
      [field]: isNaN(numValue) ? "" : numValue,
    }));
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[10000] bg-black/50 flex items-center justify-center p-3 overflow-auto"
      style={{ marginTop: "0px" }}
    >
      <div className="bg-white w-full md:w-[500px] rounded-lg shadow-xl flex flex-col">
        {/* Header */}
        <div className="flex justify-between items-center px-6 py-4 border-b">
          <h2 className="text-xl font-bold">
            {selectedItem?.employeePersonalInformationId !== 0 ? "Edit" : "Add"} Leave Credit
          </h2>
          <button onClick={onClose} className="bg-transparent border-none cursor-pointer text-gray-500 hover:text-gray-700">
            <CloseIcon />
          </button>
        </div>

        {/* Body */}
        <div className="p-6 space-y-4">
          <Input
            label="Leave Type"
            value={selectedItem?.leaveTypeDescription ?? "No Leave Type"}
            isDisabled={true}
          />

          <div className="grid grid-cols-2 gap-4">
            <NumberInput
              label="Total Credit/s"
              value={form.totalLeaveCredit}
              placeholder="0" // Visible if value is ""
              onChange={(e) => handleInputChange("totalLeaveCredit", e.target.value, false)}
              step="1"
            />

            <NumberInput
              label="Remaining Credit/s"
              value={form.remainingLeaveCredit}
              placeholder="0" // Visible if value is ""
              onChange={(e) => handleInputChange("remainingLeaveCredit", e.target.value, true)}
              step="0.5"
            />
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end space-x-2 p-5 border-t">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-200 rounded border-none cursor-pointer hover:bg-gray-300 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={() => {
              // PRE-SAVE CONVERSION: Convert any remaining empty strings back to 0 
              // so the backend receives numeric data.
              const finalData = {
                ...form,
                totalLeaveCredit: form.totalLeaveCredit === "" ? 0 : form.totalLeaveCredit,
                remainingLeaveCredit: form.remainingLeaveCredit === "" ? 0 : form.remainingLeaveCredit,
                // Ensure IDs are preserved from the selected item
                employeePersonalInformationId: selectedItem?.employeePersonalInformationId,
                leaveTypeId: selectedItem?.leaveTypeId,
                id: selectedItem?.id || 0
              };

              onSave(finalData);
            }}
            className="px-6 py-2 bg-blue-600 text-white rounded border-none cursor-pointer hover:bg-blue-700 transition-colors"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default LeaveCreditsTabAddEditModal;